import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';
import { ConditionSummary } from '../../../../../products/orderProducts.types';
import OrderTotalsSummary from '../../OrderTotalsSummary/OrderTotalsSummary';
import OrderConditionSectionLabel from './OrderConditionSectionLabel';

interface OrderConditionSummaryProps {
  totals?: ConditionSummary;
}

const OrderConditionSummary = ({ totals }: OrderConditionSummaryProps) => {
  if (!totals) {
    return null;
  }

  return (
    <Stack sx={{ gap: 1.5 }}>
      <OrderConditionSectionLabel label={LangEnum.ORDER_CONDITION_DIVISION_SUMMARY} />

      <Stack
        sx={(theme) => ({
          padding: 1.5,
          borderRadius: `${theme.shape.borderRadiusXl}px`,
          backgroundColor: theme.palette.action.hover,
        })}
      >
        <OrderTotalsSummary totals={totals} totalTestId={OrderConditionsTestIds.ORDER_TOTAL} />
      </Stack>
    </Stack>
  );
};

export default OrderConditionSummary;
